export const User = {
    emailLabel: 'email',
    firstNameLabel: 'first_name',
    lastNameLabel: 'last_name',
    birthdayLabel: 'birthday',
    salutationLabel: 'salutation',
    birthMonthLabel: 'birth_month',
    birthDayLabel: 'birth_day',
    ageGroupLabel: 'age_group',
    customerLocationLabel: 'customer_location',
    countryCodeLabel: 'country_code',
    missSalutation: 'miss_salutation',
    msSalutation: 'ms_salutation',
    mrsSalutation: 'mrs_salutation',
    mrSalutation: 'mr_salutation'
};
